import { css } from 'linaria';
import { breakpointSmallTablet, breakpointMediumTablet, breakpointTinyTablet, breakpointLargeHandset, breakpointTinyHandset } from 'common/constants';
const resetWrapper = "r3dvya1";
const contentWrapper = "c19xbjrv";
const articleWrapper = "a18y1bts";
export function ContentParsed({
  content
}) {
  return <article className={articleWrapper}>
      <div className={resetWrapper} data-cy="parsed-content">
        <section className={contentWrapper} dangerouslySetInnerHTML={{
        __html: content
      }} />
      </div>
    </article>;
}

require("./content-parsed.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./content-parsed.js");